import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../locales/translations';

const SuccessBanner = () => {
  const { language } = useLanguage();
  const text = t[language].successBanner;
  const [show, setShow] = useState(false);
  const [type, setType] = useState('success');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('success') === 'true') {
      setType('success');
      setShow(true);
      window.history.replaceState({}, '', window.location.pathname);
    } else if (params.get('canceled') === 'true') {
      setType('canceled');
      setShow(true);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => setShow(false), 7000);
      return () => clearTimeout(timer);
    }
  }, [show]);

  const config = {
    success: {
      icon: FiIcons.FiCheckCircle,
      bg: 'from-green-500/20 to-emerald-500/10',
      border: 'border-green-500/40',
      textColor: 'text-green-400',
      title: text.successTitle,
      msg: text.successMsg,
    },
    canceled: {
      icon: FiIcons.FiXCircle,
      bg: 'from-red-500/20 to-orange-500/10',
      border: 'border-red-500/40',
      textColor: 'text-red-400',
      title: text.canceledTitle,
      msg: text.canceledMsg,
    },
  };

  const c = config[type];

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -80 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -80 }}
          className="fixed top-20 left-1/2 -translate-x-1/2 z-[100] w-[90vw] max-w-md"
        >
          <div className={`bg-gradient-to-r ${c.bg} border ${c.border} rounded-2xl p-4 flex items-start gap-3 shadow-2xl backdrop-blur-xl`}>
            <SafeIcon icon={c.icon} className={`${c.textColor} text-2xl shrink-0 mt-0.5`} />
            <div className="flex-1">
              <p className={`font-black text-sm ${c.textColor}`}>{c.title}</p>
              <p className="text-gray-300 text-xs mt-0.5">{c.msg}</p>
            </div>
            <button
              onClick={() => setShow(false)}
              className="text-gray-500 hover:text-white transition-colors"
              aria-label="Close"
            >
              <SafeIcon icon={FiIcons.FiX} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SuccessBanner;